import * as React from 'react';

export const BetaFlag: React.FC<React.PropsWithChildren<{ color?: string }>> = ({ color = 'gray-700' }) => (
  <div className={`h200 h-4 px-1 font-bold text-${color} border uppercase border-${color} rounded-sm`}>Beta</div>
);
